import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { AxiosError } from 'axios';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants';
import { connectorKeys } from '@/shared/lib/query/queryKeys';

import { updateConnectorApi } from '@/entities/connector';
import type { ConnectorApiError, UpdateConnectorRequest } from '@/entities/connector';

type UpdateConnectorParams = {
  id: string;
  request: UpdateConnectorRequest;
};

export const useUpdateConnector = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: UpdateConnectorParams) => updateConnectorApi(id, request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: connectorKeys.list() });
      queryClient.invalidateQueries({ queryKey: connectorKeys.detail(variables.id) });

      message.success(NOTIFICATION_MESSAGES.CONNECTOR_UPDATE_SUCCESS_DESC);
    },
    onError: (error: AxiosError<ConnectorApiError>) => {
      const errorMessage = error.response?.data?.message ?? NOTIFICATION_MESSAGES.CONNECTOR_FORM_ERROR;
      message.error(errorMessage);
    },
  });
};
